import { defineNuxtPlugin } from '#app'
import { useSnackbarStore } from '~/stores/snackbar'

declare module '#app' {
  interface NuxtApp {
    $snackbar: {
      showMessage: (payload: import('~/stores/snackbar').SnackbarPayload) => void
    }
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      snackbar: useSnackbarStore(),
    },
  }
})
